import Panel from "./Panel";
import * as React from "react";
import { FilterProp } from "@/types/broadbandProduct";

const Filter: React.FC<{
	filterProps: FilterProp[];
}> = ({ filterProps }) => {
	const list = () => {
		return filterProps.map((filterProp, index) => {
			let localChange = (evt: any) => {
				filterProp.toggleFilter(evt.target.value);
			};

			return (
				<Panel
					key={index}
					title={filterProp.title}
					filters={filterProp.filters}
					onChange={localChange}
				/>
			);
		});
	};

	return <>{list()}</>;
};

export default Filter;
